module.exports = __webpack_public_path__ + "static/media/spot22.ec95cefd.webp";